<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                     <b-row>
                        <b-col lg="6" md="6" sm="12">
                            <span class="text-dark"><b>{{ $t('globalTrans.organization') }} </b> : {{ getOrgName(dataArray.org_id) }}</span>
                        </b-col>
                        <b-col lg="6" md="6" sm="12">
                            <span class="text-dark"><b>{{ $t('globalTrans.fiscal_year') }} </b> : {{ fiscalYear(dataArray.fiscal_year_id) }}</span>
                        </b-col>
                        <b-col lg="6" md="6" sm="12">
                            <span class="text-dark"><b>{{ $t('tp_management.total_num_of_training_course') }} </b> : {{ $n(dataArray.total_num_of_training_course, { useGrouping: false })}}</span>
                        </b-col>
                        <b-col lg="6" md="6" sm="12">
                            <span class="text-dark"><b>{{ $t('tp_management.total_num_of_refreshers_course') }} </b> : {{ $n(dataArray.total_num_of_refreshers_course, { useGrouping: false }) }}</span>
                        </b-col>
                        <b-col lg="6" md="6" sm="12">
                            <span class="text-dark"><b>{{ $t('tp_management.total_receive_amount') }} </b> : {{ $n(dataArray.total_receive_amount, { useGrouping: false }) }}</span>
                        </b-col>
                        <b-col lg="6" md="6" sm="12">
                            <span class="text-dark"><b>{{ $t('tp_management.total_cost') }} </b> : {{ $n(dataArray.total_cost, { useGrouping: false }) }}</span>
                        </b-col>
                        <b-col lg="6" md="6" sm="12">
                            <span class="text-dark"><b>{{ $t('tp_management.rest_amount') }} </b> : {{ $n(dataArray.rest_amount, { useGrouping: false }) }}</span>
                        </b-col>
                        <b-col lg="12" md="12" sm="12">
                            <span class="text-dark"><b>{{ $t('application_management.remarks') }} </b> : {{ dataArray.remarks }}</span>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col xl="12" lg="12" sm="12">
                            <b-table-simple  bordered>
                        <thead>
                           <tr class="bg-primary">
                              <th scope="col">{{ $t('globalTrans.sl_no') }}</th>
                              <th scope="col">{{ $t('application_management.document') }}</th>
                              <th scope="col">{{ $t('application_management.attachment') }}</th>
                            </tr>
                        </thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in dataArray.details" :key="index">
                              <b-td> {{ $n(index+1) }} </b-td>
                              <b-td> {{ item.document_name }} </b-td>
                              <b-td>
                                  <a v-if="item.attachment" target = '_blank' :href="trainingElearningServiceBaseUrl + 'download-attachment?file=uploads/budget/attachment/' + item.attachment" download>{{ $t('globalTrans.view') }}</a>
                              </b-td>
                           </b-tr>
                         </b-tbody>
                         </b-table-simple>
                            <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.close') }}</b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { trainingElearningServiceBaseUrl } from '../../../../../config/api_config'
import { core } from '../../../../../config/pluginInit'
export default {
    props: ['id'],
    components: {
    },
    created () {
        if (this.id) {
            const tmp = this.getBudgetManagementData()
            this.dataArray = tmp
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            trainingElearningServiceBaseUrl: trainingElearningServiceBaseUrl
        }
    },
    computed: {
        currentLocale () {
            return this.$i18n.locale
        }
    },
    methods: {
        getBudgetManagementData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        getOrgName (orgId) {
            const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        fiscalYear (fiscalYearId) {
            const fiscalYear = this.$store.state.commonObj.fiscalYearList.find(item => item.value === fiscalYearId)
            if (this.$i18n.locale === 'bn') {
                return fiscalYear.text_bn
            } else {
                return fiscalYear.text_en
            }
        }
    }
}

</script>
